module.exports = __webpack_public_path__ + "img/cm.10c1b29c.svg";